import { Tag } from '@ekhodealer/ekho-common/rev';

/**
 * Map lead type to Tag accent color
 * Uses the type value as received to determine color
 */
const getTypeAccent = (type: string | undefined): 'neutral' | 1 | 2 | 3 | 4 | 5 | 6 | 7 => {
	if (!type) return 'neutral';

	switch (type) {
		case 'Abandoned cart':
			return 7; // Green
		case 'Abandoned preorder cart':
			return 5; // Orange
		case 'Rejected financing':
			return 3; // Teal
		case 'Buy in person':
			return 2; // Purple
		case 'Inquiry':
			return 1; // Purple
		case 'Inbound':
			return 4; // Blue
		default:
			return 'neutral';
	}
};

interface TypeCellProps {
	type: string;
}

const getTypeDisplayText = (type: string | undefined): string => {
	if (!type) return '—';
	if (type === 'Abandoned preorder cart') return 'Abandoned preorder';
	if (type === 'Abandoned cart') return 'Abandoned cart';
	return type;
};

export const TypeCell = ({ type }: TypeCellProps) => {
	const typeText = getTypeDisplayText(type);
	const accent = getTypeAccent(type);

	return (
		<div style={{ minWidth: '140px' }}>
			<Tag size='medium' accent={accent} children={typeText} appearance='outline' />
		</div>
	);
};
